@if (isStudent) {
  <div
    khA11yDialog
    class="modal-body game-modal p-md-5"
    data-testid="session-expired-modal">
    <div khA11yLabelSource class="text-center kh-small-text-primary kh-lg-title-text">
      {{ 'SESSION_EXPIRED_MODAL.TITLE' | translate }}
    </div>

    <div class="text-center kh-medium-text mt-kh-3">
      {{ 'SESSION_EXPIRED_MODAL.MESSAGE' | translate }}
    </div>

    <div class="text-right khModalButtons">
      <button
        type="button"
        class="session-expired-modal__button kh-green-button kh-green-accessible kh-heading-sm py-kh-2 px-kh-3 mt-kh-4"
        [disabled]="isSubmitting"
        [attr.aria-busy]="isSubmitting"
        (click)="onCtaClick()"
        data-testid="session-expired-modal-cta">
        @if (isSubmitting) {
          <span class="spinner-border spinner-border-sm session-expired-modal__spinner" aria-hidden="true"></span>
        }
        {{ 'SESSION_EXPIRED_MODAL.CTA' | translate }}
      </button>
    </div>
  </div>
}
@else {
  <div khA11yDialog>
    <div class="modal-container" data-testid="session-expired-modal">
      <div khA11yLabelSource class="kh-heading-sm kh-text-primary mb-kh-2 w-100 center">
        {{ 'SESSION_EXPIRED_MODAL.TITLE' | translate }}
      </div>

      <div class="kh-body-md kh-text-primary mb-kh-5 w-100 center">
        {{ 'SESSION_EXPIRED_MODAL.MESSAGE' | translate }}
      </div>

      <div class="w-100 center">
        <button
          type="button"
          class="session-expired-modal__button kh-primary-button kh-medium-title-text"
          [disabled]="isSubmitting"
          [attr.aria-busy]="isSubmitting"
          (click)="onCtaClick()"
          data-testid="session-expired-modal-cta">
          @if (isSubmitting) {
            <span class="spinner-border spinner-border-sm session-expired-modal__spinner" aria-hidden="true"></span>
          }
          {{ 'SESSION_EXPIRED_MODAL.CTA' | translate }}
        </button>
      </div>
    </div>
  </div>
}
